import { FC, useEffect, useState } from "react";
import { X } from "lucide-react";
import { UserSearch } from "src/containers";
import { UserSearchItem } from "src/components";

interface ManagerSummary {
	id: string;
	name: string;
}

interface Props {
	onChange: (value: string) => void;
	initialManager?: ManagerSummary | null;
}

const ManagerPicker: FC<Props> = ({ onChange, initialManager }) => {
	// Local selection mirrors the StoreUser shape just well enough to
	// render UserSearchItem; the id may be string (.NET GUID) or number
	// (legacy Django) so we type it loosely.
	type LocalSelection = { id: string | number; name: string } | null;
	const [selected, setSelected] = useState<LocalSelection>(
		initialManager ? { id: initialManager.id, name: initialManager.name } : null
	);
	const [searchValue, setSearchValue] = useState("");

	useEffect(() => {
		setSelected(
			initialManager
				? { id: initialManager.id, name: initialManager.name }
				: null
		);
		setSearchValue("");
	}, [initialManager?.id, initialManager?.name]);

	const handleClear = () => {
		setSelected(null);
		setSearchValue("");
		onChange("");
	};

	const handleSearchChange = (user: Partial<StoreUser>) => {
		if (user.id) {
			setSelected({ id: user.id, name: user.name ?? "" });
			setSearchValue("");
			onChange(String(user.id));
		} else {
			setSearchValue(user.name ?? "");
		}
	};

	if (selected?.id) {
		return (
			<div className="rounded-md border border-border bg-white px-3 py-2">
				<UserSearchItem
					user={selected as StoreUser}
					icon={<X size={16} aria-label="Remove manager" />}
					iconEvent={handleClear}
				/>
			</div>
		);
	}

	return <UserSearch value={searchValue} onChange={handleSearchChange} />;
};

export default ManagerPicker;
